// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"G64DFKwR_jvP","icon":"_22_HPXEZaN_v","name":"_1DlwlRM3M980","size":"_1xe84esjjl6l","selected":"_7myTpVOPjWSr"};